var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"m512.001 84.853-84.853-84.853-171.147 171.147-171.148-171.147-84.853 84.853 171.148 171.147-171.148 171.148 84.853 84.853 171.148-171.147 171.147 171.147 84.853-84.853-171.148-171.148z"})));
}

Close.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 512.001 512.001","height":"512","viewBox":"0 0 512.001 512.001","width":"512"};

module.exports = Close;

Close.default = Close;
